"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkboxGroupNovoDark = exports.checkboxGroupNovo = exports.checkboxGroup = exports.checkboxNovoDark = exports.checkboxNovo = exports.checkbox = void 0;
const polished_1 = require("polished");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const checkbox = {
    // Deprecated, instead of `accentColor` you should use `backgroundColor`
    accentColor: color_const_1.default.cloudyBlue,
    backgroundColor: color_const_1.default.cloudyBlue,
    checkboxShadowColorFocus: color_const_1.default.dodgerBlue,
    checkboxMargin: size_const_1.default.default,
    checkboxSize: size_const_1.default.medium,
    disabledColor: (0, polished_1.rgba)(color_const_1.default.dodgerBlue, 0.5),
    checkedBackgroundColor: color_const_1.default.dodgerBlue,
    checkboxIconColorFocus: color_const_1.default.dodgerBlue300,
    checkboxIconColorHover: color_const_1.default.dodgerBlue300,
    iconSet: 'classic',
    labelColor: color_const_1.default.pickledBluewood800,
    labelDisabledColor: (0, polished_1.rgba)(color_const_1.default.pickledBluewood800, 0.5),
    labelHeight: size_const_1.default.medium,
    checkboxFocusBorderRadius: '4px',
    checkboxFocusBorderSize: '2px',
};
exports.checkbox = checkbox;
const checkboxNovo = {
    backgroundColor: novo.ui03,
    checkboxMargin: novo.spacing04,
    checkboxSize: '24px',
    checkedBackgroundColor: novo.action04,
    disabledColor: novo.icon06,
    checkboxShadowColorFocus: novo.action04,
    checkboxIconColorFocus: novo.focus01,
    checkboxIconColorHover: novo.focus01,
    iconSet: 'novo',
    labelColor: novo.textColor01,
    labelDisabledColor: novo.disabled02,
    checkboxFocusBorderRadius: '7px',
    checkboxFocusBorderSize: '2px',
};
exports.checkboxNovo = checkboxNovo;
const checkboxNovoDark = {
    ...checkboxNovo,
    backgroundColor: novoDark.ui03,
    checkedBackgroundColor: novoDark.action04,
    checkboxIconColorFocus: novoDark.focus01,
    checkboxIconColorHover: novoDark.focus01,
    disabledColor: novoDark.icon06,
    labelColor: novoDark.textColor01,
    labelDisabledColor: novoDark.disabled02,
};
exports.checkboxNovoDark = checkboxNovoDark;
const checkboxGroup = {
    verticalGroupMargin: size_const_1.default.default,
    horizontalGroupMargin: size_const_1.default.default2x,
};
exports.checkboxGroup = checkboxGroup;
const checkboxGroupNovo = {
    verticalGroupMargin: novo.spacing03,
    horizontalGroupMargin: novo.spacing06,
};
exports.checkboxGroupNovo = checkboxGroupNovo;
const checkboxGroupNovoDark = {
    ...checkboxGroupNovo,
};
exports.checkboxGroupNovoDark = checkboxGroupNovoDark;
